import { renderSections } from "./sectionRegistry";

/**
 * Product landing template — used by the one product page type
 * (`caustic-soda-flakes`, Figma `4669-6369`).
 *
 * Identical in shape to `SupplierLandingTemplate`: a pure loop over
 * `config.sections` with no hardcoded sections. The product page differs from the
 * supplier pages only in WHICH section types it lists (`productHero`,
 * `aboutTable`, `howItsMade`, `features`, `storageHandling`, `productWhyChoose`),
 * all of which are registered in `sectionRegistry.js`. If this template ever
 * needs a hardcoded section, the section split is wrong.
 *
 * The two templates are kept as separate modules rather than merged because
 * `pages/markets/[region]/[slug].jsx` dispatches on `config.template`, and a
 * distinct component is what makes an unknown template value visible.
 */
export default function ProductLandingTemplate({ config }) {
  return <main>{renderSections(config.sections)}</main>;
}
